module.exports = __webpack_public_path__ + "static/qualcomm_logo-7b20c9f808fc177fc325c88de3366a73.png";